import { getDefaultView } from '@/utils/viewHelpers';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { DocumentHead } from '@/components/core/DocumentHead';
import { useMemo } from 'react';

export const Route = createFileRoute('/$tenantId/_layout/reports/')({
  component: ReportsRedirect,
});

function ReportsRedirect() {
  const { tenantId } = Route.useParams();
  const view = getDefaultView('reports');

  const metadataKeys = useMemo(() => {
    switch (view) {
      case 'transactions':
        return {
          titleKey: 'page.reports.transactions.title',
          descriptionKey: 'page.reports.transactions.description',
        };
      case 'files':
        return {
          titleKey: 'page.reports.files.title',
          descriptionKey: 'page.reports.files.description',
        };
    }
  }, [view]);

  return (
    <>
      {metadataKeys && (
        <DocumentHead
          titleKey={metadataKeys.titleKey}
          descriptionKey={metadataKeys.descriptionKey}
          resetOnUnmount={false}
        />
      )}
      <Navigate
        to="/$tenantId/reports/$view"
        params={{ tenantId, view }}
        replace
      />
    </>
  );
}
